import { LoginPage } from "@/features/auth/pages/Login";

const Login = () => {
  return <LoginPage />;
};

export default Login;
